import Vue from 'vue'

import EmailLink from '@/components/atoms/EmailLink'
import RouteLink from '@/components/atoms/RouteLink'
import PromiseButton from '@/components/atoms/PromiseButton'
import Display from '@/components/atoms/Display'
import Tabs from '@/components/atoms/Tabs'
import StatusBadge from '@/components/atoms/StatusBadge'
import ModuleIcon from '@/components/atoms/ModuleIcon'
import ProgressBar from '@/components/atoms/ProgressBar'
import Loading from '@/components/atoms/Loading'

[EmailLink, RouteLink, PromiseButton, Display, Tabs, StatusBadge, ModuleIcon, ProgressBar, Loading]
  .forEach(c => Vue.component(c.name, c))
